function buildStaggerDelays(count, step = 90, baseDelay = 0) {
    return Array.from({ length: count }, (_, index) => baseDelay + index * step);
}

function prepareStaggerReveal(root, elements, options = {}) {
    const step = Number.isFinite(options.step) ? options.step : 90;
    const baseDelay = Number.isFinite(options.baseDelay) ? options.baseDelay : 0;
    const delayProperty = options.delayProperty || '--animate-delay';
    const delays = buildStaggerDelays(elements.length, step, baseDelay);

    if (root?.dataset) {
        root.dataset.animateReady = '1';
        root.dataset.animateState = 'hidden';
        root.dataset.animateMotion = options.prefersReducedMotion ? 'reduced' : 'full';
    }

    elements.forEach((el, index) => {
        const delay = delays[index];
        if (el?.style?.setProperty) {
            el.style.setProperty(delayProperty, `${delay}ms`);
        }
        if (el?.dataset) {
            el.dataset.animateItem = '1';
            el.dataset.animateIndex = String(index);
            el.dataset.animateDelay = String(delay);
        }
    });

    return {
        delays,
        items: elements,
    };
}

function playStaggerReveal(root) {
    if (root?.dataset) {
        if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
            window.requestAnimationFrame(() => {
                root.dataset.animateState = 'visible';
            });
            return;
        }

        root.dataset.animateState = 'visible';
    }
}

const staggerReveal = {
    name: 'stagger-reveal',
    targetSelector: '[data-animate-item="1"]',
    prepare: prepareStaggerReveal,
    play: playStaggerReveal,
    buildStaggerDelays,
};

export {
    buildStaggerDelays,
    playStaggerReveal,
    prepareStaggerReveal,
    staggerReveal,
};
